import { render, staticRenderFns } from "./OrganisationSelect.vue?vue&type=template&id=29650602&scoped=true"
import script from "./OrganisationSelect.vue?vue&type=script&lang=ts"
export * from "./OrganisationSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29650602",
  null
  
)

export default component.exports